var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineRulerPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.47 22.75c-2.42 0-3.75-1.33-3.75-3.75V5c0-2.42 1.33-3.75 3.75-3.75h4c2.42 0 3.75 1.33 3.75 3.75v14c0 2.42-1.34 3.75-3.75 3.75h-4zM12.22 5v14c0 1.58.67 2.25 2.25 2.25h4c1.58 0 2.25-.67 2.25-2.25V5c0-1.58-.67-2.25-2.25-2.25h-4c-1.58 0-2.25.67-2.25 2.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.47 6.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h5c.41 0 .75.34.75.75s-.34.75-.75.75h-5zM11.47 18.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4c.41 0 .75.34.75.75s-.34.75-.75.75h-4zM16.47 14.75l-5.01-.05c-.41 0-.75-.34-.74-.76 0-.41.34-.74.75-.74h.01l5 .05c.41 0 .75.34.74.76-.01.41-.34.74-.75.74-.01 0-.01 0 0 0zM11.47 10.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3c.41 0 .75.34.75.75s-.34.75-.75.75h-3z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.13 21.18-.82-1.36c-.3-.5-.53-1.32-.53-1.9V4.95c0-2.04 1.66-3.7 3.7-3.7s3.7 1.66 3.7 3.7v12.96c0 .58-.23 1.4-.53 1.9l-.82 1.36c-.57.99-1.43 1.55-2.34 1.55-.91 0-1.77-.56-2.36-1.54zm.16-16.23v12.96c0 .31.15.86.31 1.13l.82 1.36c.31.52.7.81 1.07.81.37 0 .76-.3 1.07-.81l.82-1.36c.16-.27.31-.82.31-1.13V4.95c0-1.21-.99-2.2-2.2-2.2-1.21 0-2.2.99-2.2 2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.53 7.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h5.91c.41 0 .75.34.75.75s-.34.75-.75.75H2.53z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineRulerPen);
export default __webpack_public_path__ + "static/media/vuesax-outline-ruler-pen.ac454a03552c8691269ab0e31d3397a1.svg";
export { ForwardRef as ReactComponent };